import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/utils/helpers';

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({ className, type = 'button', ...props }, ref) => {
  return <button ref={ref} type={type} className={cn('ui-icon-button', className)} {...props} />;
});

IconButton.displayName = 'IconButton';

export default IconButton;

